import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import {COLORS} from 'config/constants';

const ProductHeading = ({count}: ProductHeadingProps) => {
  const {t} = useTranslation();

  return <Typography className='product-heading' variant='h6' sx={{
    marginTop: '24px',
    marginBottom: '24px',
    color: COLORS.BLACK_DARK,
    fontWeight: 700,
    lineHeight: '26px',
    letterSpacing: 0,
  }}>
    {t('common__text__products')}
    {count > 0 && <Typography component='sup' variant='caption' sx={{
      marginLeft: '5px',
      color: COLORS.LIGHT_TEXT_DISABLED,
      fontSize: '13px',
      fontWeight: 400,
      lineHeight: 0,
      verticalAlign: 'super',
      letterSpacing: 0,
    }}>{count}</Typography>}
  </Typography>;
};

export default ProductHeading;
